import React, { useState } from 'react';
import { withStyles } from '@mui/styles';
import MuiTableCell from '@mui/material/TableCell';
import {
  Box,
  Table,
  TableRow,
  TableBody,
  TablePagination
} from '@mui/material';
import { Icon } from '@iconify/react';
import handPaper from '@iconify-icons/fa-solid/hand-paper';
import checkIcon from '@iconify-icons/fa-solid/check';
import userCheck from '@iconify-icons/fa-solid/user-check';
import question from '@iconify-icons/fa-solid/question';

import HeadTable from '../../../../../../common/utils/DataTableHelper/TableHead';
import {
  TableLoader,
  TableNoDataPlaceholder
} from '../../../../../../components/TableLoader';
import { useGetWaiverStatus } from '@/api/documents/staff';

const TableCell = withStyles({
  root: {
    borderBottom: '1px solid #F4F6F8'
  }
})(MuiTableCell);

function createData(ID, service, details, status, statusNotes) {
  return {
    ID,
    service,
    details,
    status,
    statusNotes
  };
}

const TABLE_HEAD = [
  {
    id: 'service',
    label: 'Service'
  },
  {
    id: 'status',
    label: 'Status'
  },
  {
    id: 'statusNotes',
    label: 'Status Notes'
  }
];

export default function Waivers(props) {
  const { customerAllData } = props;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const { data: waiverData, isLoading: waiverLoading } = useGetWaiverStatus(
    { customerId: customerAllData?.id },
    { query: { enabled: !!customerAllData?.id } }
  );

  const allWaivers = waiverData?.data?.rows || [];

  const TableData =
    allWaivers.map((item, idx) =>
      createData(
        idx + 1,
        item?.service,
        item?.details || 'No Detail Available',
        item?.status,
        item?.status
      )
    ) || [];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - TableData.length) : 0;

  return (
    <div>
      <Table>
        <HeadTable headLabel={TABLE_HEAD} />
        {waiverLoading ? (
          <TableLoader />
        ) : TableData.length > 0 ? (
          <TableBody>
            {TableData.slice(
              page * rowsPerPage,
              page * rowsPerPage + rowsPerPage
            ).map(row => {
              return (
                <TableRow key={row.ID}>
                  <TableCell>{row?.service}</TableCell>
                  <TableCell>
                    {row.status === 'cleared' ? (
                      <Icon icon={checkIcon} color="green" />
                    ) : <Icon icon={handPaper} color="red" /> &&
                      row.status.includes('consideration approved') ? (
                      <Icon icon={userCheck} color="green" />
                    ) : <Icon icon={handPaper} color="red" /> &&
                      row.status === 'consideration review needed' ? (
                      <Icon icon={question} color="orange" />
                    ) : (
                      <Icon icon={handPaper} color="red" />
                    )}
                  </TableCell>
                  <TableCell>{row.status}</TableCell>
                </TableRow>
              );
            })}
            {emptyRows > 0 && (
              <TableRow>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
        ) : (
          <TableNoDataPlaceholder />
        )}
      </Table>
      <Box sx={{ position: 'relative' }}>
        <TablePagination
          page={page}
          component="div"
          count={TableData.length}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          rowsPerPageOptions={[20, 50, 100]}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </div>
  );
}
